import simpleRestProvider from "ra-data-simple-rest";
import { fetchUtils } from "react-admin";

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }

  // Skip Authorization for public routes
  const publicRoutes = ["forgot-password", "reset-password"];
  const isPublicRoute = publicRoutes.some((route) => url.includes(route));
  if (!isPublicRoute) {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const { access_token } = auth;

    options.headers.set("Authorization", `Bearer ${access_token}`);
  }
  return fetchUtils.fetchJson(url, options).then((response) => {
    // Some endpoints don't return Content-Range. Inject a synthetic one so
    // ra-data-simple-rest can build pagination without throwing.
    if (
      Array.isArray(response.json) &&
      !response.headers.has("content-range")
    ) {
      const headers = new Headers(response.headers);
      headers.set(
        "content-range",
        `items 0-${response.json.length}/${response.json.length}`
      );
      return { ...response, headers };
    }
    return response;
  });
};

/**
 * Current behaviour: react-admin handles List filter by storing them on the url
 * Problem: If we use a tabbed view to show more than one filtered List on the same page, they all try to use the url to handle filters,
 * so filters for different views get mixed
 * Solution: we qualify the filter names using the entity names 'entity##column', so we can handle filters for different lists on the same url
 */
const processQualifiedFilters = (resource, params) => {
  if (params.filter) {
    for (const column in params.filter) {
      const [table, rawcol] = column.split("##");

      if (rawcol) {
        if (table === resource) {
          params.filter[rawcol] = params.filter[column];
        }

        delete params.filter[column];
      }
    }
  }
};

const rest_provider = simpleRestProvider(window.ENV.API_URL, httpClient);

// Resources whose backend update endpoint requires PATCH instead of PUT.
const PATCH_RESOURCES = new Set(["discount-plans"]);

export const dataProvider = new Proxy(rest_provider, {
  get(target, name) {
    if (name === "deleteMany") {
      return (resource, params) => {
        return Promise.all(
          params.ids.map((id) =>
            httpClient(`${window.ENV.API_URL}/${resource}/${id}`, {
              method: "DELETE",
            })
          )
        ).then(() => ({ data: params.ids }));
      };
    }
    if (name === "update") {
      return (resource, params) => {
        if (PATCH_RESOURCES.has(resource)) {
          return httpClient(`${window.ENV.API_URL}/${resource}/${params.id}`, {
            method: "PATCH",
            body: JSON.stringify(params.data),
          }).then(({ json }) => ({ data: json }));
        }
        return target.update(resource, params);
      };
    }
    return function (resource, params) {
      processQualifiedFilters(resource, params);
      return target[name](resource, params);
    };
  },
});
